<template>
  <div >
    <h4 class="title-report">Response by Hours</h4>
    <v-layout column align-end >
      <v-flex xs3>
        <treeselect
            :max-height="100"
            :multiple="true"
            :options="optionsTreeSelect"
            placeholder="Select your device(s) OR Groups"
            v-model="valuesFiltering"
            @input="loadData()"
          />
        </v-flex> 
    </v-layout>
    <v-flex xs12>
      <hr>
      <charts :options="chartOptions"></charts>
    </v-flex> 
  </div>
</template>
<script>
import Treeselect from '@riophae/vue-treeselect';

import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  components: {
    Treeselect,
  },
  props: {
    dates: {
      type: Object,
      default: function () { return { startDate: 'empty', endDate: 'empty' } },
      required: false,
    },
    round_id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      values: null,
      valuesFiltering: [],
      optionsTreeSelect: [],
      chartOptions: {
        chart: {
          type: 'column'
        },
        title: {
          text: null
        },
        xAxis: {
          categories: ['1 AM', '2 AM', '3 AM', '4 AM', '5 AM', '6 AM', '7 AM', '8 AM', '9 AM', '10 AM', '11 AM', '12 PM', '1 PM', '2 PM', '3 PM', '4 PM', '5 PM', '6 PM', '7 PM', '8 PM', '9 PM', '10 PM', '11 PM', '12 PM']
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          },
          stackLabels: {
            enabled: false,
          }
        },
        tooltip: {
          shared: true,
          pointFormat: '<span style="color:{series.color}">{point.y} | {series.name}</span>: ({point.percentage:.0f}%)<br/>'
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          column: {
            stacking: 'percent'
          }
        },
        series: [{
          name: 'Bad',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          color: '#ed3b3b',
        }, {
          name: 'Poor',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          color: '#e87531',
        }, {
          name: 'Average',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          color: '#ffd700',
        }, {
          name: 'Good',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          color: '#407790',  
        }, {
          name: 'Excellent',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          color: '#138315'
        }]
      }
    };
  },
  watch: {
    dates: {
      handler: function (val, oldVal) {
        this.loadData();
      },
      deep: true
    },
  },
  mounted () {
    this.loadData();
    this.getTreeSelect();
  },
  methods: {
    loadData: function () {
      let aux_filter;
      aux_filter = this.valuesFiltering;
      if (this.valuesFiltering.length === 0) {
        aux_filter = 'empty';
      }
      window.axios.get(`dashboards/round/${this.round_id}/responses-devices-by-hours/${this.dates.startDate}/${this.dates.endDate}/${aux_filter}`).then(response => {
        this.chartOptions.series[0].data = response.data.data.byHourData[0];
        this.chartOptions.series[1].data = response.data.data.byHourData[1];
        this.chartOptions.series[2].data = response.data.data.byHourData[2];
        this.chartOptions.series[3].data = response.data.data.byHourData[3];
        this.chartOptions.series[4].data = response.data.data.byHourData[4];
      });
    },
    getTreeSelect () {
      window.axios.get('devices/tree-devices-filtering-round/' + this.round_id).then(response => {
        this.optionsTreeSelect = response.data.tree_select_devices;
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/client/rounds/dashboard/graphs/ResponsesDevicesByHours.vue